type LegacyDeliveryLocation = {
  postalCode?: number | string | null;
  city?: string | null;
  district?: string | null;
  address?: string | null;
};

const joinParts = (value: LegacyDeliveryLocation) =>
  [value.postalCode, value.city, value.district, value.address]
    .filter((part) => part != null && part !== "")
    .join(" ");

// deliveryLocation 已由 FullAddress jsonb 改為 text，舊資料被 jsonb::text 轉成 JSON 字串
export function formatDeliveryLocation(value: unknown): string {
  if (value == null) return "";

  if (typeof value === "object" && !Array.isArray(value)) {
    return joinParts(value as LegacyDeliveryLocation);
  }

  if (typeof value !== "string") return String(value);

  const text = value.trim();
  if (!text.startsWith("{")) return value;

  try {
    const parsed = JSON.parse(text);
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return joinParts(parsed as LegacyDeliveryLocation) || value;
    }
  } catch {
    return value;
  }

  return value;
}

export function toUnitPrice(value: unknown): number | null {
  if (value === "" || value == null) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}
